// extracted by mini-css-extract-plugin
export default {"divContainer":"App_divContainer__typw6"};